import { get, post, put } from "@/shared/utils/fetchApi";
import type { MemoryKind } from "@/features/Memory/types/MemoryTypes";
import type {
  Learning,
  LearningFrequency,
  LearningReference,
  LearningsTarget,
  LearningStatus,
  ReviewRunResult,
  WorkspaceLearningSettings,
} from "../types/LearningTypes";

/**
 * Brain Learnings (AB#87286). A caixa é a mesma no Brain e no My view (`view`); quem vê e
 * quem decide cada proposta é decidido pela api.
 */
export class LearningsService {
  private static params(target: LearningsTarget, extra: Record<string, string> = {}): string {
    const params = new URLSearchParams({ view: target.view, ...extra });
    if (target.productId) params.set("product_id", target.productId);
    return params.toString();
  }

  static list(target: LearningsTarget, status: LearningStatus): Promise<Learning[]> {
    return get<Learning[]>(`/learnings?${LearningsService.params(target, { status })}`);
  }

  static count(target: LearningsTarget): Promise<{ pending: number }> {
    return get<{ pending: number }>(`/learnings/count?${LearningsService.params(target)}`);
  }

  static accept(id: string, edits: { content?: string; kind?: MemoryKind } = {}): Promise<Learning> {
    return post<Learning>(`/learnings/${id}/accept`, edits);
  }

  static reject(id: string): Promise<Learning> {
    return post<Learning>(`/learnings/${id}/reject`, {});
  }

  /** Desfaz um aprendizado da Memory; ele não é aprendido de novo. */
  static remove(id: string): Promise<Learning> {
    return post<Learning>(`/learnings/${id}/remove`, {});
  }

  static references(id: string): Promise<LearningReference[]> {
    return get<LearningReference[]>(`/learnings/${id}/references`);
  }

  static settings(productId: string): Promise<WorkspaceLearningSettings> {
    return get<WorkspaceLearningSettings>(`/learnings/settings?product_id=${encodeURIComponent(productId)}`);
  }

  static saveSettings(
    productId: string,
    input: { enabled?: boolean; frequency?: LearningFrequency },
  ): Promise<WorkspaceLearningSettings> {
    return put<WorkspaceLearningSettings>("/learnings/settings", { product_id: productId, ...input });
  }

  static reviewNow(productId: string): Promise<ReviewRunResult> {
    return post<ReviewRunResult>("/learnings/review", { product_id: productId });
  }

  static mySettings(): Promise<{ opt_out: boolean }> {
    return get<{ opt_out: boolean }>("/learnings/me/settings");
  }

  static saveMySettings(optOut: boolean): Promise<{ opt_out: boolean }> {
    return put<{ opt_out: boolean }>("/learnings/me/settings", { opt_out: optOut });
  }
}
